import React from 'react'
import { DateRangePicker } from 'rsuite';

export default function DatePicker(props) {

  const { defaultValue, disabledDate, placement, paddingLeft }=props;
  const styles = { minHeight: '50px !important', border: 'none !important', display: 'block', paddingLeft: (paddingLeft !== undefined) ? paddingLeft : 85};

  const {dateRange,dateRangeChange}=props;
  const [startDate, endDate] = dateRange;
  // Support an empty range: only build a default value when both bounds are set,
  // otherwise render the placeholder instead of new Date(null) (= 01/01/1970).
  const rangeDefault = (startDate && endDate) ? [new Date(startDate), new Date(endDate)] : null;

  return (
    <div className="dashboard-datepicker">
        <DateRangePicker
            size="lg"
            style={styles}
            appearance="subtle"
            placeholder="Select Date Range"
            className="form-control hide-border-control"
            character=" - "
            format='dd/MM/yyyy'
            placement={placement}
            defaultValue={rangeDefault}
            disabledDate={disabledDate}
            startdate={startDate}
            enddate={endDate}
            onChange={(update) => {
              dateRangeChange(update);
          }}
            cleanable={false}
        />
    </div>
  )
}

